(function () {
  var root = document.querySelector('[data-lf-home]');
  if (!root) return;
  var V = JSON.parse(document.getElementById('lf-variants').textContent);
  var state = { pack: '10', size: 'L' };
  var NAMES = { '3': '3-Pack', '5': '5-Pack', '10': '10-Pack' };
  var packBtns = root.querySelectorAll('[data-pack]');
  var sizeBtns = root.querySelectorAll('[data-size]');
  var sub = root.querySelector('[data-add-sub]');
  var err = root.querySelector('[data-add-error]');

  function render() {
    packBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.pack === state.pack)); });
    sizeBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.size === state.size)); });
    if (sub) sub.textContent = NAMES[state.pack] + ', size ' + state.size;
  }
  packBtns.forEach(function (b) { b.addEventListener('click', function () { state.pack = b.dataset.pack; render(); }); });
  sizeBtns.forEach(function (b) { b.addEventListener('click', function () { state.size = b.dataset.size; render(); }); });
  root.querySelectorAll('[data-choose]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.pack = b.dataset.choose; render();
      var shop = document.getElementById('shop');
      if (shop) shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  var menuBtn = root.querySelector('[data-menu]');
  var drawer = root.querySelector('[data-drawer]');
  if (menuBtn && drawer) menuBtn.addEventListener('click', function () {
    var open = drawer.classList.toggle('is-open');
    menuBtn.setAttribute('aria-expanded', String(open));
  });

  var add = root.querySelector('[data-add]');
  if (add) add.addEventListener('click', function () {
    var id = V[state.pack] && V[state.pack][state.size];
    if (!id) return;
    if (err) err.hidden = true;
    add.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { if (err) err.hidden = false; add.disabled = false; });
  });

  render();
})();
